<div id="login-page" class="container-fluid">

    <div class="row">
 
      <div id="login-box">
    
        <div class="login-item">
          <img class="login-logo" src="assets/img/mobile_icono_blue.png" />
        </div>
        <mat-card-title>Actualizar Contraseña</mat-card-title>
        <hr>
        <form [formGroup]="resetpassForm">

  
          <div class="login-item">
            <mat-form-field appearance="fill">
              <mat-label>Ingrese nueva Contrase&ntilde;a</mat-label>
              <span matPrefix>
                <mat-icon class="icon-valid" *ngIf="fieldValid('password')">lock</mat-icon>
                <mat-icon class="icon-invalid" *ngIf="!fieldValid('password')">error</mat-icon>
              </span>
              <input matInput type="password" formControlName="password">
              <mat-error>Contrase&ntilde;a inv&aacute;lida. M&iacute;nimo 8 Caract&eacute;res</mat-error>
            </mat-form-field>
          </div>
          <div class="login-item">
            <mat-form-field appearance="fill">
              <mat-label>Repita la nueva Contrase&ntilde;a</mat-label>
              <span matPrefix>
                <mat-icon class="icon-valid" *ngIf="fieldValid('repeat_password')">lock</mat-icon>
                <mat-icon class="icon-invalid" *ngIf="!fieldValid('repeat_password')">error</mat-icon>
              </span>
              <input matInput type="password" formControlName="repeat_password">
              <mat-error>Contrase&ntilde;a inv&aacute;lida. M&iacute;nimo 8 Caract&eacute;res</mat-error>
            </mat-form-field>
          </div>
  
          <mat-error *ngIf="resetpassForm.controls['repeat_password'].errors">Los passwords ingresados son diferentes</mat-error>

          <div class="login-item">
            <button mat-flat-button color="primary" [disabled]="!buttonEnabled() || showSpinner"
              (click)="send()">
              <span *ngIf="!showSpinner">Enviar</span>
              <span *ngIf="showSpinner">
                <mat-spinner [diameter]="24"></mat-spinner>
              </span>
            </button>
          </div>
  
        </form>
  
      </div>
    </div>
  
    <div>
      <p class="copyright">&copy; Aceitera General Deheza S.A. | 1948 - {{year}}   |   <a class="ml-3" [routerLink]="'/'" >Volver al Login</a></p>
    </div>
  
  </div>


